import "../../css/pages/strategicCapability.scss";
import slashImageBlock from "../modules/slashImageBlock";

import SelectFilter from "../modules/selectFilter";
import LazyPagination from "../modules/lazyPagination";
import ListingSearch from "../modules/listingSearch";
import tabsToggle from "../modules/tabsToggle";
import sectionNav from "../modules/sectionNav";
import BasePage from "./base";
import relatedInsights from "../modules/relatedInsights";
import accordion from "../modules/accordion";
import sectionNavV3 from "../modules/sectionNavV3";
import largeCardCarousel from "../modules/largeCardCarousel";
import anchorSets from "../modules/anchorSets";

class ListingPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();

        sectionNav.init();
        tabsToggle.init();
        relatedInsights.init();
        window.addEventListener("load", accordion.init);
        sectionNavV3.init();
        largeCardCarousel.init();
        anchorSets.init();
        slashImageBlock.init();

        new SelectFilter();

        new LazyPagination({
            context: this.context || ""
        });

        new ListingSearch();
    }
}

new ListingPage();
